import Vue from 'vue'
import VueRouter from 'vue-router'
import cookies from 'vue-cookies'
// import {ApiUrl} from '../../public/globalConfig'
Vue.prototype.$cookies = cookies
Vue.use(VueRouter)
var ApiUrl = window.global_config.BASE_URL
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err)
}

// console.log(window.location.protocol + window.location.host)
const routes = [
  {
    path: '/',
    component: () => import('../views/home.vue')
  },
  {
    path: '/pc_index',
    component: () => import('../views/pcHome.vue')
  },
  {
    path: '/security',
    component: () => import('../views/security/index.vue')
  },
  {
    path: '/password',
    component: () => import('../views/security/password.vue')
  },
  {
    path: '/retrieve',
    component: () => import('../views/security/retrieve.vue')
  },
  {
    path: '/lookup',
    name: 'lookup',
    component: () => import('../views/security/lookup.vue'),
    beforeEnter: (to, from, next) => {
      let a = cookies.get('auth')
      // console.log(a)
      if (!a) {
        window.location.href =
          ApiUrl + '/user/login?callback_url=' + ApiUrl + '/server/index.html#/pc_index/'
      } else {
        next()
      }
    }
  },
  {
    path: '/change',
    component: () => import('../views/security/change.vue'),
    beforeEnter: (to, from, next) => {
      let a = cookies.get('auth')
      // console.log(a)
      if (!a) {
        window.location.href =
          ApiUrl + '/user/login?callback_url=' + ApiUrl + '/server/index.html#/pc_index/'
      } else {
        next()
      }
    }
  },
  {
    path: '/phone',
    component: () => import('../views/security/phone.vue')
  },
  {
    path: '/recharge',
    component: () => import('../views/recharge/index.vue'),
    beforeEnter: (to, from, next) => {
      let a = cookies.get('auth')
      // console.log(a)
      if (!a) {
        window.location.href =
          ApiUrl + '/user/login?callback_url=' + ApiUrl + '/server/index.html#/pc_index/'
      } else {
        next()
      }
    }
  },
  {
    path: '/notReceived',
    component: () => import('../views/recharge/notReceived.vue')
  },
  {
    path: '/other',
    component: () => import('../views/recharge/other.vue')
  },
  {
    path: '/obtain',
    component: () => import('../views/recharge/obtain.vue')
  },
  {
    path: '/suggest',
    component: () => import('../views/suggest/index.vue'),
    beforeEnter: (to, from, next) => {
      let a = cookies.get('auth')
      // console.log(a)
      if (!a) {
        window.location.href =
          ApiUrl + '/user/login?callback_url=' + ApiUrl + '/server/index.html#/pc_index/'
      } else {
        next()
      }
    }
  },
  {
    path: '/feedback',
    component: () => import('../views/suggest/feedback.vue')
  },
  {
    path: '/complaint',
    component: () => import('../views/suggest/complaint.vue')
  },
  {
    path: '/routine',
    component: () => import('../views/suggest/routine.vue')
  },
  {
    path: '/bug',
    component: () => import('../views/bug/index.vue'),
    beforeEnter: (to, from, next) => {
      let a = cookies.get('auth')
      // console.log(a)
      if (!a) {
        window.location.href =
          ApiUrl + '/user/login?callback_url=' + ApiUrl + '/server/index.html#/pc_index/'
      } else {
        next()
      }
    }
  },
  {
    path: '/unable',
    component: () => import('../views/bug/unable.vue')
  },
  {
    path: '/anomalous',
    component: () => import('../views/bug/anomalous.vue')
  },
  {
    path: '/operation',
    component: () => import('../views/bug/operation.vue')
  },
  {
    path: '/query',
    component: () => import('../views/query/index.vue')
  },
  {
    path: '/inquiry',
    component: () => import('../views/query/inquiry.vue')
  },
  {
    path: '/processing/:id',
    component: () => import('../views/query/processing.vue')
  },
  {
    path: '/processingFF',
    component: () => import('../views/query/processingFF.vue')
  },
  {
    path: '/handled/:id',
    component: () => import('../views/query/handled.vue')
  },
  {
    path: '/handledF',
    component: () => import('../views/query/handledF.vue')
  },
  {
    path: '/record/:id',
    component: () => import('../views/query/record.vue')
  },
  {
    path: '/recordF',
    component: () => import('../views/query/recordF.vue')
  },
  {
    path: '/report/:id',
    component: () => import('../views/query/report.vue')
  },
  {
    path: '/reportF',
    component: () => import('../views/query/reportF.vue')
  },
  {
    path: '/mobileLogin',
    component: () => import('../views/query/mobileLogin.vue')
  },
  // 开票
  {
    path: '/invoicing',
    component: () => import('../views/invoice/invoicing.vue'),
    beforeEnter: (to, from, next) => {
      let a = cookies.get('auth')
      // console.log(a)
      if (!a) {
        window.location.href = ApiUrl + '/user/login?callback_url=' + encodeURIComponent(ApiUrl + '/server/index.html#/invoicing')
      } else {
        next()
      }
    }
  },
  // 历史
  {
    path: '/history',
    component: () => import('../views/invoice/history.vue'),
    beforeEnter: (to, from, next) => {
      let a = cookies.get('auth')
      // console.log(a)
      if (!a) {
        window.location.href = ApiUrl + '/user/login?callback_url=' + encodeURIComponent(ApiUrl + '/server/index.html#/history')
      } else {
        next()
      }
    }
  },
  // 直充中心
  {
    path: '/charge/9K2Z1q',
    component: () => import('../views/vip/charge.vue'),
    beforeEnter: (to, from, next) => {
      let a = cookies.get('auth')
      if (!a) {
        window.location.href =
          ApiUrl + '/user/login?callback_url=' + encodeURIComponent(ApiUrl + '/server/index.html#/charge/9K2Z1q')
      } else {
        next()
      }
      // next()
    }
  },
  // 签到有礼
  {
    path: '/signIn',
    component: () => import('../views/signIn/signIn.vue'),
    meta: { title: '帝国每日签到'},
    beforeEnter: (to, from, next) => {
      if (to.meta.title) {
        document.title = to.meta.title
      }
      next()
    }
  },
  
]
const router = new VueRouter({
  routes
})
// router.beforeEach((to, from, next) => {

//   if (a.length == 0) {
//     window.location.href = 'https://my.9665.com/user/login.html'
//   }else{
//     next()
//   }

// })
export default router
